import { ReactElement, SVGProps } from 'react';
import BaseSvgImage from '@Shared/Ui/BaseSvgImage';
import { cn } from '@Shared/Helpers/Utilities';

interface SvgImageProps extends SVGProps<SVGSVGElement> {
    testid?: string;
    path?: string;
    icon: string;
    className?: string | null;
}

function SvgImage({
    className = null,
    testid = 'svg-image',
    path = '/assets/images/svg/new-icons',
    icon,
    ...rest
}: SvgImageProps): ReactElement {
    return (
        <BaseSvgImage
            testid={testid}
            className={cn('size-6', className)}
            icon={icon}
            path={path}
            {...rest}
        />
    );
}

export default SvgImage;
